import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMasterOrderEmailSendReadinessQueryVariables = Types.Exact<{
  masterOrderId: Types.Scalars['String']['input'];
}>;


export type GetMasterOrderEmailSendReadinessQuery = { __typename?: 'Query', masterOrderEmailSendReadiness?: { __typename?: 'OrderEmailSendReadinessData', routes: Array<{ __typename?: 'OrderEmailRouteReadinessData', route: Types.OrderEmailDeliveryRoute, isReady: boolean, blockers: Array<Types.OrderEmailSendBlocker> }> } | null };


export const GetMasterOrderEmailSendReadinessDocument = new TypedDocumentString(`
    query GetMasterOrderEmailSendReadiness($masterOrderId: String!) {
  masterOrderEmailSendReadiness(masterOrderId: $masterOrderId) {
    routes {
      route
      isReady
      blockers
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMasterOrderEmailSendReadiness: build.query<GetMasterOrderEmailSendReadinessQuery, GetMasterOrderEmailSendReadinessQueryVariables>({
      query: (variables) => ({ document: GetMasterOrderEmailSendReadinessDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMasterOrderEmailSendReadinessQuery, useLazyGetMasterOrderEmailSendReadinessQuery } = injectedRtkApi;
